import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface SectionLabelProps {
    index: string
    label: string
    className?: string
}

export const SectionLabel: FC<SectionLabelProps> = ({ index, label, className }): ReactNode => {
    return (
        <p className={cn('flex items-center gap-3 font-mono text-xs uppercase tracking-[0.22em] text-muted-foreground', className)}>
            <span className='text-brand-bright'>
                {index}
            </span>

            <span aria-hidden='true' className='h-px w-10 bg-border' />

            {label}
        </p>
    )
}
